import { render, staticRenderFns } from "./EventRegister.vue?vue&type=template&id=4dc3d0a9&scoped=true&"
import script from "./EventRegister.vue?vue&type=script&lang=js&"
export * from "./EventRegister.vue?vue&type=script&lang=js&"
import style0 from "./EventRegister.vue?vue&type=style&index=0&id=4dc3d0a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc3d0a9",
  null
  
)

export default component.exports